import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { addItem, CartItem } from '../../redux/slices/cardSlice';
import { RootState } from '../../redux/store';

import './pizza-block.scss';
const typesNames = ['тонкое', 'традиционное'];

type PizzaBlock = {
  id: string;
  imageUrl: string;
  title: string;
  sizes: number[];
  price: number;
  types: number[];
};

const PizzaBlock: React.FC<PizzaBlock> = (props) => {
  const { id, imageUrl, title, sizes, price, types } = props;
  const dispatch = useDispatch();
  const [activeType, setActiveType] = useState(0);
  const [activeSize, setActiveSize] = useState(0);
  const pizzaInBlock = useSelector((state: RootState) =>
    state.cart.items.filter((obj: any) => obj.id === id),
  );
  const pizzaCount = pizzaInBlock.reduce((num: number, pizza: any) => {
    return pizza.count + num;
  }, 0);
  const addOnClickPizzas = () => {
    const pizza: CartItem = {
      id,
      title,
      price,
      imageUrl,
      type: typesNames[activeType],
      size: sizes[activeSize],
      count: 0,
    };

    dispatch(addItem(pizza));
  };

  return (
    <div className="pizza-block__wrapper">
      <div className="pizza-block">
        <img className="pizza-block__image" src={imageUrl} alt="Pizza" />
        <h4 className="pizza-block__title">{title}</h4>
        <div className="pizza-block__selector">
          <ul>
            {types.map((item, i) => {
              return (
                <li
                  className={activeType === i ? 'active' : undefined}
                  key={i}
                  onClick={() => setActiveType(i)}>
                  {typesNames[item]}
                </li>
              );
            })}
          </ul>
          <ul>
            {sizes.map((item, i) => {
              return (
                <li
                  className={activeSize === i ? 'active' : undefined}
                  key={i}
                  onClick={() => setActiveSize(i)}>
                  {item} см.
                </li>
              );
            })}
          </ul>
        </div>
        <div className="pizza-block__bottom">
          <div className="pizza-block__price">от {price} ₴</div>
          <div
            onClick={() => {
              addOnClickPizzas();
            }}
            className="button button--outline button--add">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.8 4.8H7.2V1.2C7.2 0.5373 6.6627 0 6 0C5.3373 0 4.8 0.5373 4.8 1.2V4.8H1.2C0.5373 4.8 0 5.3373 0 6C0 6.6627 0.5373 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.3373 12 6 12C6.6627 12 7.2 11.4627 7.2 10.8V7.2H10.8C11.4627 7.2 12 6.6627 12 6C12 5.3373 11.4627 4.8 10.8 4.8Z"
                fill="white"
              />
            </svg>
            <span>Добавить</span>
            <i>{pizzaCount}</i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PizzaBlock;
